module.exports = {"130635100":"蠡吾镇","130635101":"留史镇","130635102":"大百尺镇","130635103":"辛兴镇","130635104":"北郭丹镇","130635105":"万安镇","130635106":"桑园镇","130635107":"南庄镇","130635108":"大曲堤镇","130635200":"小陈乡","130635201":"林堡乡","130635202":"北埝头乡","130635203":"鲍墟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130635.json
// module id = 153
// module chunks = 0